import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Tools|Exam Review|`;

export type SPExamReviewFormLoc = 'SPExamReviewFormCheckboxLabel';

export const spExamReviewFormLocs: LocDefs<SPExamReviewFormLoc> = {
	SPExamReviewFormCheckboxLabel: {
		defaultValue: 'Notify candidate on invalidation',
		description: 'Label for the option to send candidate an automated email.',
		displayPath: `${dpRoot}|Send Email`,
		displayType: 'Label',
		feature: HubFeature.ExamSecurity,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<SPExamReviewFormLoc>(spExamReviewFormLocs);
export type SPExamReviewFormLocType = LocMap<SPExamReviewFormLoc>;
